import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './WhyGenix.css';

const rotaFeatures = [
  'AI-driven data parsing',
  'Parse data from Excel or plain text',
  'Auto-generates smart schedules',
  'Handles last-minute changes',
  'Real-time updates',
  'Reduces human error',
];

const WhyGenixRota = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-20% 0px -20% 0px' });
  return (
    <motion.section
      className="why-genix-section why-genix-roata-section"
      id="why-genix-roata-section"
      style={{marginTop:'0'}}
      ref={ref}
      initial={{ opacity: 0, x: -80 }}
      animate={isInView ? { opacity: 1, x: 0 } : {}}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="why-genix-container" style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 206}}>
        <div className="content-side" style={{flex: 1, minWidth: 320, marginTop: 0}}>
          <h2 style={{color: '#fff', fontSize: '2.8rem', fontWeight: 700, marginBottom: 36, lineHeight: 1.15,textAlign:'justify'}}>
            What Makes<br />Genix Rota Smarter<br />Than the Rest?
          </h2>
          <div className="features-list" style={{marginRight:111}}>
            {rotaFeatures.map((feature, idx) => (
              <div key={feature} className="feature-item" style={{display: 'flex', alignItems: 'center', color: '#fff', fontSize: '1rem', marginBottom: 4}}>
                <span style={{
                  width: 22,
                  height: 22,
                  minWidth: 22,
                  minHeight: 22,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'white',
                  borderRadius: '50%',
                  color: '#0191c6',
                  fontSize: 16,
                  fontWeight: 700,
                  marginRight: 10,
                  flexShrink: 0
                }}>
                  ✓
                </span>
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="why-genix-image-side" style={{flex: 1, minWidth: 320, display: 'flex', justifyContent: 'center', position: 'relative', maxWidth: 800,marginTop:'50px'}}>
          <img 
            src="/images/GenixRoata.png" 
            alt="Genix Rota Dashboard" 
            style={{width: '100%', maxWidth: 750, borderRadius: 18, boxShadow: '0 8px 32px rgba(0,0,0,0.08)'}}
          />
          <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
            <div style={{width: 80, height: 80, background: 'rgba(255,255,255,0.95)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.10)', cursor: 'pointer'}}>
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="19" cy="19" r="19" fill="#0098db"/>
                <polygon points="15,12 28,19 15,26" fill="#fff"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default WhyGenixRota; 